import { IArquivoCard } from "../interfaces/IArquivoCard";
import { IArquivoEmpresa } from "../interfaces/IArquivoEmpresa";
import api from "./Api";

class ArquivoEmpresaService {
    async cadastrarArquivo(arquivoEmpresa: IArquivoEmpresa): Promise<IArquivoEmpresa> {
        const { data: result } = await api.post<IArquivoEmpresa>(`ArquivoEmpresa/${arquivoEmpresa.empresaID}`, arquivoEmpresa);
        return result;
    }

    async buscarTodos(empresaID: number, esteiraID: number): Promise<IArquivoEmpresa[]> {
        const { data: result } = await api.get<IArquivoEmpresa[]>(`ArquivoEmpresa/${empresaID}/${esteiraID}`);
        return result;
    }

    async liscarArquivoCard(conta: string, esteiraID: number): Promise<IArquivoCard[]> {
        const { data: result } = await api.get<IArquivoCard[]>(`ArquivoEmpresa/listarCardsConta/${esteiraID}/${conta}`);
        return result;
    }

    async cadastrarArquivoCard(arquivo: IArquivoCard): Promise<IArquivoCard> {
        const { data: result } = await api.post<IArquivoCard>(`ArquivoEmpresa/cadastrarCard/${arquivo.esteiraID}/${arquivo.codigoContabil}`, arquivo);
        return result;
    }

    async removerArquivoCard(id: number): Promise<void> {
        await api.post(`ArquivoEmpresa/removerArquivoCard/${id}`);
    }

    async removerArquivoEmpresa(id: number): Promise<void> {
        await api.post(`ArquivoEmpresa/remover-arquivo-empresa/${id}`);
    }

    async processar(id: number, esteiraID: number, tipo: string, tipoArquivo: string, config: any): Promise<void> {
        await api.post(`Importacao/ecd/enviarposicaoFinanceiraEmail/${esteiraID}/${tipo}/${tipoArquivo}/${id}`, {
            ...config
        }, {
            baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
        });
    }

    async processarPosicao(arquivoID: number, esteiraID: number, active: boolean, config: any): Promise<void> {
        await api.post(`PosicaoFinanceira/processar/esteira/${esteiraID}/arquivo/${arquivoID}?active=${active}`, {
            ...config
        }, {
            baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3'
        });
    }

    async concluirImportacaoBloqueio(esteiraID: number): Promise<void> {
        await api.patch(`Esteira/${esteiraID}/concluir-importacao-arquivos`, {
        }, {
            baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3'
        });
    }

    async enviarSaldoInicialParaFila(esteiraID: number): Promise<void> {
        await api.post(`SaldoInicial/esteira/${esteiraID}/processar-arquivos`, {
        }, {
            baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3'
        });
    }

    async processarNovo(esteiraID: number): Promise<void> {
        await api.post(`Folha/ProcessarResumo/${esteiraID}`);
    }

    async processarNovoPagamentoFolha(esteiraID: number): Promise<void> {
        await api.post(`Folha/ProcessarPagamentoFolha/${esteiraID}`);
    }

    async processarPosicaoTributo(esteiraID: number, arquivoID: number): Promise<void> {
        await api.post(`Posicao/Tributos/${esteiraID}/${arquivoID}`);
    }

    async processarPosicaoTributoRetido(esteiraID: number, arquivoID: number): Promise<void> {
        await api.post(`Posicao/Retido/${esteiraID}/${arquivoID}`);
    }

    async processarPosicaoISS(esteiraID: number, arquivoID: number): Promise<void> {
        await api.post(`Posicao/ISS/${esteiraID}/${arquivoID}`);
    }


    async processarPosicaoImobilizado(esteiraID: number, arquivoID: number): Promise<void> {
        await api.post(`Posicao/Imobilizado/${esteiraID}/${arquivoID}`);
    }
}


export default new ArquivoEmpresaService();